/* GENERATED by scripts/gen-data.mjs — chapter "model-families" (from s2.js + s3.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { NodeDef } from '../../types';

export const N_MODEL_FAMILIES: NodeDef = {
  "id": "model-families",
  "tagKey": "path:model-families.tag",
  "x": 320,
  "y": 40,
  "w": 220,
  "h": 116,
  "titleKey": "path:model-families.title",
  "subKey": "path:model-families.sub",
  "blocks": [
    {
      "id": "model-families.b1",
      "kind": "explain",
      "xp": 15,
      "titleKey": "path:model-families.b1.title",
      "bodyKey": "path:model-families.b1.body",
      "flowKey": "path:model-families.b1.flow",
      "read": [
        "zshot"
      ]
    },
    {
      "id": "model-families.b2",
      "kind": "film",
      "xp": 25,
      "titleKey": "path:model-families.b2.title",
      "film": "f-families"
    },
    {
      "id": "model-families.b3o",
      "kind": "options",
      "xp": 20,
      "titleKey": "path:model-families.b3o.title",
      "opts": {
        "list": [
          {
            "nKey": "path:model-families.b3o.opts.0.n",
            "wKey": "path:model-families.b3o.opts.0.w",
            "uKey": "path:model-families.b3o.opts.0.u",
            "cKey": "path:model-families.b3o.opts.0.c",
            "slug": "token-classification"
          },
          {
            "nKey": "path:model-families.b3o.opts.1.n",
            "wKey": "path:model-families.b3o.opts.1.w",
            "uKey": "path:model-families.b3o.opts.1.u",
            "cKey": "path:model-families.b3o.opts.1.c",
            "slug": "sentence-embeddings"
          },
          {
            "nKey": "path:model-families.b3o.opts.2.n",
            "wKey": "path:model-families.b3o.opts.2.w",
            "uKey": "path:model-families.b3o.opts.2.u",
            "cKey": "path:model-families.b3o.opts.2.c",
            "slug": "cross-encoder-reranker"
          },
          {
            "nKey": "path:model-families.b3o.opts.3.n",
            "wKey": "path:model-families.b3o.opts.3.w",
            "uKey": "path:model-families.b3o.opts.3.u",
            "cKey": "path:model-families.b3o.opts.3.c",
            "slug": "generative-decoding"
          },
          {
            "nKey": "path:model-families.b3o.opts.4.n",
            "wKey": "path:model-families.b3o.opts.4.w",
            "uKey": "path:model-families.b3o.opts.4.u",
            "cKey": "path:model-families.b3o.opts.4.c",
            "slug": "distilled-student-model"
          }
        ],
        "ref": "sbert"
      }
    },
    {
      "id": "model-families.b3",
      "kind": "math",
      "xp": 15,
      "titleKey": "path:model-families.b3.title",
      "math": {
        "exprKey": "path:model-families.b3.math.expr",
        "readKey": "path:model-families.b3.math.read",
        "useKey": "path:model-families.b3.math.use",
        "ref": "sbert"
      }
    },
    {
      "id": "model-families.b4",
      "kind": "check",
      "xp": 45,
      "titleKey": "path:model-families.b4.title",
      "ex": {
        "type": "classify",
        "binsKey": "path:model-families.b4.ex.bins",
        "binCount": 4,
        "items": [
          {
            "tKey": "path:model-families.b4.ex.items.0.t",
            "bin": 0,
            "whyKey": "path:model-families.b4.ex.items.0.why"
          },
          {
            "tKey": "path:model-families.b4.ex.items.1.t",
            "bin": 1,
            "whyKey": "path:model-families.b4.ex.items.1.why"
          },
          {
            "tKey": "path:model-families.b4.ex.items.2.t",
            "bin": 2,
            "whyKey": "path:model-families.b4.ex.items.2.why"
          },
          {
            "tKey": "path:model-families.b4.ex.items.3.t",
            "bin": 3,
            "whyKey": "path:model-families.b4.ex.items.3.why"
          }
        ]
      }
    }
  ]
};
